import { stateName } from './constants';

const localState = state => state[stateName];

export function getAreProblemOptionsLoading(state) {
  return localState(state).areProblemOptionsLoading;
}
export function getAreRatingsOptionsLoading(state) {
  return localState(state).areRatingsOptionsLoading;
}
export function getIsProblemsModalOpen(state) {
  return localState(state).isProblemsModalOpen;
}
export function getIsFeedbackModalOpen(state) {
  return localState(state).isFeedbackModalOpen;
}
export function getProblemOptions(state) {
  return localState(state).problemOptions;
}
export function getRatings(state) {
  return localState(state).ratings;
}